/**
 * Site planner structure catalog — Construx SKUs + SoftPlan public examples.
 * Assets: public/models/<slug>.glb locally (gitignored).
 * Production: REACT_APP_MODELS_BASE_URL → Blob/CDN (docs/MODEL_ASSETS.md).
 * Docs: docs/ADU_SITE_PLANNER.md, docs/SOFTPLAN_WEB3D_CONVERSION.md
 */

import { SOFTPLAN_EXAMPLES_CATALOG } from './softplanExamplesCatalog';

/** Build Construx developed models (from CMS SoftPlan mainUrl). */
export const CONSTRUX_CATALOG = [
  {
    slug: 'r1as',
    label: 'R1AS',
    softPlanId: '31036',
    origin: 'construx',
  },
  {
    slug: 'r1de',
    label: 'R1DE',
    softPlanId: '24827',
    origin: 'construx',
  },
  {
    slug: 'r1ee',
    label: 'R1EE',
    softPlanId: '25258',
    origin: 'construx',
  },
  {
    slug: 'r2as',
    label: 'R2AS',
    softPlanId: '19032',
    origin: 'construx',
  },
  {
    slug: 'r2ce',
    label: 'R2CE',
    softPlanId: '28049',
    origin: 'construx',
  },
  {
    slug: 'h2ae',
    label: 'H2AE',
    softPlanId: '26001',
    origin: 'construx',
  },
  {
    slug: 'h2be',
    label: 'H2BE',
    softPlanId: '24881',
    origin: 'construx',
  },
  {
    slug: 's2ae',
    label: 'S2AE',
    softPlanId: '30745',
    origin: 'construx',
  },
];

/** @deprecated use CONSTRUX_CATALOG — kept as alias for older imports */
export const SITE_PLANNER_CATALOG = CONSTRUX_CATALOG;

export const DEFAULT_SITE_PLANNER_MODEL = 'r1as';

/**
 * Public Vercel Blob prefix for Construx catalog GLBs (docs/MODEL_ASSETS.md).
 * Safe to ship in the client — objects are public-read.
 * Used when REACT_APP_MODELS_BASE_URL is missing from the build env.
 */
export const DEFAULT_MODELS_BLOB_BASE =
  'https://ekqciisicrfqj7n1.public.blob.vercel-storage.com/models';

/** Trailing-slash-safe base for remote GLBs (empty → same-origin /models). */
export function modelsBaseUrl() {
  const raw = (process.env.REACT_APP_MODELS_BASE_URL || '').trim();
  if (raw) return raw.replace(/\/+$/, '');
  // CRA inlines NODE_ENV at build time — production builds must not fall back
  // to /models/*.glb (gitignored; SPA returns index.html).
  if (process.env.NODE_ENV === 'production') {
    return DEFAULT_MODELS_BLOB_BASE;
  }
  return '';
}

/**
 * Absolute or root-relative URL for a catalog GLB.
 * Local dev: `/models/<slug>.glb`. Production: Blob CDN (env or default).
 */
export function catalogGlbUrl(slug) {
  const file = `${slug}.glb`;
  const base = modelsBaseUrl();
  if (!base) return `/models/${file}`;
  return `${base}/${file}`;
}

export function allCatalogEntries() {
  return [...CONSTRUX_CATALOG, ...SOFTPLAN_EXAMPLES_CATALOG];
}

export function catalogEntry(slug) {
  return allCatalogEntries().find((m) => m.slug === slug) || null;
}

export function catalogLabel(slug) {
  const entry = catalogEntry(slug);
  if (!entry) return String(slug || '').toUpperCase();
  if (entry.origin === 'softplan') return entry.label || entry.title || entry.slug;
  return entry.label || String(slug).toUpperCase();
}

export function catalogOrigin(slug) {
  return catalogEntry(slug)?.origin || 'construx';
}

export function construxCatalog() {
  return CONSTRUX_CATALOG;
}

export function softplanExamplesCatalog() {
  return SOFTPLAN_EXAMPLES_CATALOG;
}
